'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default =
// import {Link} from 'react-router';

NotFound;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NotFound() {
  return _react2.default.createElement(_components.WarningPage, { text: '您所访问的链接不存在' });
}
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/NotFound/NotFound.js
 ** module id = 1506
 ** module chunks = 0
 **/